(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.announcement-bar__item'));
      this.current = 0;
      this.autoplayDelay = 4000;
      this.timer = null;

      if (this.items.length <= 1) return;

      this.querySelector('.announcement-bar__arrow--prev')
        .addEventListener('click', () => { this.move(-1); this.resetTimer(); });
      this.querySelector('.announcement-bar__arrow--next')
        .addEventListener('click', () => { this.move(1); this.resetTimer(); });

      this.observer = new IntersectionObserver((entries) => {
        entries[0].isIntersecting ? this.startTimer() : this.stopTimer();
      });
      this.observer.observe(this);

      this.updateArrowColors();
    }

    disconnectedCallback() {
      this.stopTimer();
      if (this.observer) this.observer.disconnect();
    }

    show(index) {
      this.items[this.current].classList.remove('is-active');
      this.current = (index + this.items.length) % this.items.length;
      this.items[this.current].classList.add('is-active');
    }

    move(dir) {
      this.show(this.current + dir);
    }

    startTimer() {
      this.timer = setInterval(() => this.move(1), this.autoplayDelay);
    }

    stopTimer() {
      clearInterval(this.timer);
    }

    resetTimer() {
      this.stopTimer();
      this.startTimer();
    }

    // Keep arrows visible against custom background colors
    updateArrowColors() {
      const textColor = this.querySelector('aside').style.color;
      this.querySelectorAll('.announcement-bar__arrow').forEach(btn => {
        btn.style.color = textColor;
      });
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.ticking = false;
      this.isScrolled = false;
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.onScroll(); // set initial state
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;

      requestAnimationFrame(() => {
        const y = window.pageYOffset || document.documentElement.scrollTop;

        // Hysteresis thresholds (tune these)
        const ON_AT = 48;
        const OFF_AT = 16;

        if (!this.isScrolled && y > ON_AT) this.isScrolled = true;
        else if (this.isScrolled && y < OFF_AT) this.isScrolled = false;

        document.documentElement.classList.toggle('is-scrolled', this.isScrolled);

        this.ticking = false;
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroSection extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.observer = null
      this.visibilityTimeout = null
      this.createObserver()
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect()
        this.observer = null
      }
      if (this.visibilityTimeout) {
        clearTimeout(this.visibilityTimeout)
      }
    }

    createObserver() {
      const ctx = this
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (ctx.visibilityTimeout) {
            clearTimeout(ctx.visibilityTimeout)
          }
          if (entry.isIntersecting) {
            ctx.visibilityTimeout = setTimeout(() => {
              entry.target.classList.add("is-visible")
            }, 250)
          } else {
            ctx.visibilityTimeout = setTimeout(() => {
              entry.target.classList.remove("is-visible")
            }, 250)
          }
        })
      }, {threshold: 0.333})
      this.observer.observe(this.querySelector('.hero'))
    }
  }

  customElements.define('hero-section', HeroSection)

  } catch(e) { console.error(e); }
})();
})();
